module.exports = __webpack_public_path__ + "assets/b11.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b11.png
// module id = 581
// module chunks = 0